export enum EGroupementPrelevementAnalyse {

    PrelevementPhaseAnalysePhase = 1,
    PrelevementPotAnalysePhase = 2,
    PrelevementPotAnalysePot = 3,
}